(function(){
'use strict';

// VARIANT SELECT (Event Delegation – überlebt DOM-Refresh)
document.addEventListener('change', function(e) {
  var select = e.target.closest('.cart-recs__variant-select');
  if (!select) return;
  var card = select.closest('.cart-recs__card');
  if (!card) return;
  var opt = select.options[select.selectedIndex];
  var btn = card.querySelector('[data-rec-add-btn]');
  var priceWrap = card.querySelector('.cart-recs__price-wrap');
  var img = card.querySelector('.cart-recs__image-wrap img');

  if (btn) {
    btn.setAttribute('data-variant-id', opt.value);
    btn.disabled = opt.dataset.available === 'false';
  }

  if (priceWrap) {
    if (opt.dataset.hasSale === 'true') {
      priceWrap.innerHTML = '<span class="cart-recs__price">' + opt.dataset.price + '</span><span class="cart-recs__price--compare">' + opt.dataset.comparePrice + '</span>';
    } else {
      priceWrap.innerHTML = '<span class="cart-recs__price">' + opt.dataset.price + '</span>';
    }
  }

  if (img && opt.dataset.image) {
    img.src = opt.dataset.image;
  }
});

// ADD TO CART
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-rec-add-btn]');
  if (!btn) return;
  e.preventDefault();
  var vid = btn.getAttribute('data-variant-id');
  if (!vid) return;
  btn.classList.add('is-adding');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
  })
  .then(function(r) { if (!r.ok) throw new Error('f'); return r.json(); })
  .then(function() {
    btn.classList.remove('is-adding');
    btn.classList.add('is-added');
    refreshDrawer();
    setTimeout(function() { btn.classList.remove('is-added'); }, 2000);
  })
  .catch(function() { btn.classList.remove('is-adding'); });
});

// REFRESH DRAWER
function refreshDrawer() {
  var cd = document.querySelector('cart-drawer');
  var wasEmpty = cd && cd.classList.contains('is-empty');

  // We just added an item — cart can't be empty. Drop the `is-empty` class
  // NOW so CSS like `cart-drawer.is-empty .drawer__inner { display: grid }`
  // doesn't keep the empty-state layout (free-shipping bar jumping down).
  if (cd) cd.classList.remove('is-empty');
  var cdItems = document.querySelector('cart-drawer-items');
  if (cdItems) cdItems.classList.remove('is-empty');

  fetch('/cart?section_id=cart-drawer')
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');

      if (wasEmpty) {
        var newInner = doc.querySelector('.drawer__inner');
        var curInner = document.querySelector('cart-drawer .drawer__inner');
        if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
      } else {
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function(sel) {
          var target = document.querySelector(sel);
          var source = doc.querySelector(sel);
          if (target && source) target.replaceWith(source);
        });
      }

      // Sync truth from the new server-rendered DOM (handles edge cases like
      // failed add or unexpected empty cart). Don't wait for a /cart.js call.
      var newCartDrawer = doc.querySelector('cart-drawer');
      if (cd && newCartDrawer) {
        cd.classList.toggle('is-empty', newCartDrawer.classList.contains('is-empty'));
      }

      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        if (cd) cd.classList.toggle('is-empty', cart.item_count === 0);
        document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function(el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('.cart-count-bubble').forEach(function(b) {
          if (cart.item_count > 0) b.removeAttribute('hidden');
        });
      });
    });
}


// MOBILE DOTS
function initMobileDots() {
  var list = document.querySelector('.cart-recs-mobile-slot .cart-recs__list');
  if (!list) return;

  var cards = list.querySelectorAll('.cart-recs__card');
  var dotsEl = list.closest('.cart-recs').querySelector('.cart-recs__dots');
  if (!dotsEl || cards.length < 2) return;

  dotsEl.innerHTML = '';
  cards.forEach(function(_, i) {
    var d = document.createElement('span');
    d.className = 'cart-recs__dot' + (i === 0 ? ' is-active' : '');
    d.addEventListener('click', function() {
      var gap = parseFloat(getComputedStyle(list).gap) || 8;
      list.scrollTo({ left: i * (cards[0].offsetWidth + gap), behavior: 'smooth' });
    });
    dotsEl.appendChild(d);
  });

  list.addEventListener('scroll', function() {
    var gap = parseFloat(getComputedStyle(list).gap) || 8;
    var idx = Math.round(list.scrollLeft / (cards[0].offsetWidth + gap));
    idx = Math.max(0, Math.min(idx, cards.length - 1));
    dotsEl.querySelectorAll('.cart-recs__dot').forEach(function(d, i) {
      d.classList.toggle('is-active', i === idx);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initMobileDots();
  });
} else {
  initMobileDots();
}
})();
